const ClickFonteObject = "Click Fonte Object";
const ClickFonteObjectAction = "Click_Fonte_Object_Action";

export default ClickFonteObject;
export { ClickFonteObject, ClickFonteObjectAction };
